import React from 'react';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';

const DataTableComponent = ({ data }) => {
  const columns = Object.keys(data[0]).map(key => ({
    name: key.replace(/_/g, ' ').toUpperCase(),
    selector: row => row[key],
    sortable: true,
  }));

  const customStyles = {
    rows: {
      style: {
        minHeight: '40px',
      },
    },
  };

  return <DataTable columns={columns} data={data} customStyles={customStyles} />;
};

DataTableComponent.propTypes = {
  data: PropTypes.array,
};

export default DataTableComponent;
